'use client';
import { Button } from '@curology/ui-components-web/react/Button';
import { ClockIcon } from '@curology/ui-components-web/react/Icon/icons/ClockIcon';
import { Label } from '@curology/ui-components-web/react/Label';
import { Link } from '@curology/ui-components-web/react/Link';
import { Typography } from '@curology/ui-components-web/react/Typography';
import Image from 'next/image';
import React, { useState } from 'react';

import { useNavigation } from '@/components/flow/hooks/useNavigation';
import { trackEvent, AnalyticsEvent } from '@/utils/analytics';

export const HowItWorks = () => {
  const { onNext } = useNavigation();

  const [nextButtonDisabled, setNextButtonDisabled] = useState(false);

  return (
    <div className="cur-max-w-[375px] cur-mx-auto cur-px-4 cur-py-8">
      <Typography className="cur-mb-6" size="h2">
        How it works in 3 simple steps
      </Typography>
      <div className="cur-bg-[#FFFFFF] cur-flex cur-mb-4 cur-mt-6 cur-p-4">
        <div className="cur-flex-1 cur-pr-2">
          <div className="cur-h-full cur-relative">
            <Image
              alt="How it works - Step 1"
              className="cur-object-cover"
              fill={true}
              src="https://images.ctfassets.net/8pzh4g8cs30t/58GBZOicoJp9qKDgGoE95v/6a69c01b8a083c96496b27dca310e3a4/how_it_works_step_1.png?h=250"
            />
          </div>
        </div>
        <div className="cur-flex-1 cur-pl-2">
          <Label className="cur-mb-2">Step 1</Label>
          <Typography className="cur-my-2" weight="bold">
            Tell us about your skin and goals
          </Typography>
          <div className="cur-flex cur-items-center cur-mt-2">
            <ClockIcon className="cur-mr-2" size="sm" />
            <Typography>About 4 min</Typography>
          </div>
        </div>
      </div>
      <div className="cur-bg-[#FFFFFF] cur-flex cur-my-4 cur-p-4">
        <div className="cur-flex-1 cur-pr-2">
          <div className="cur-h-full cur-relative">
            <Image
              alt="How it works - Step 2"
              className="cur-object-cover"
              fill={true}
              src="https://images.ctfassets.net/8pzh4g8cs30t/GoiTsnXAZ4PnzKGD7vWYi/b6bc69c86488bbff7bf551bad5083ac4/how_it_works_step_2.png?h=250"
            />
          </div>
        </div>
        <div className="cur-flex-1 cur-pl-2">
          <Label className="cur-mb-2">Step 2</Label>
          <Typography className="cur-my-2" weight="bold">
            Get your personalized routine
          </Typography>
        </div>
      </div>
      <div className="cur-bg-[#FFFFFF] cur-flex cur-mb-6 cur-mt-4 cur-p-4">
        <div className="cur-flex-1 cur-pr-2">
          <div className="cur-h-full cur-relative">
            <Image
              alt="How it works - Step 3"
              className="cur-object-cover"
              fill={true}
              src="https://images.ctfassets.net/8pzh4g8cs30t/78Xw94o145hTEqM2XukJ9/a5757b4e666cee5fd1b53fedee744e5c/how_it_works_step_3.png?h=250"
            />
          </div>
        </div>
        <div className="cur-flex-1 cur-pl-2">
          <Label className="cur-mb-2">Step 3</Label>
          <Typography className="cur-my-2" weight="bold">
            Share your health info and snap some selfies
          </Typography>
          <div className="cur-flex cur-items-center cur-mt-2">
            <ClockIcon className="cur-mr-2" size="sm" />
            <Typography>About 4 min</Typography>
          </div>
        </div>
      </div>
      <div className="cur-my-6">
        <Button
          className="cur-w-full"
          disabled={nextButtonDisabled}
          onClick={() => {
            setNextButtonDisabled(true);

            trackEvent(AnalyticsEvent.HOW_IT_WORKS_COMPLETED);

            onNext();
          }}
        >
          Get started
        </Button>
      </div>
      <Typography className="cur-mt-6 cur-text-center">
        Already have an account? <Link href="/auth/login">Log in</Link>
      </Typography>
    </div>
  );
};
